import { fetcher } from "utils";

import { GetUsersCoordiResponse, IPage } from "typings";

export const get__users__coordi = (params?: { page: IPage }): Promise<GetUsersCoordiResponse> =>
  fetcher.get("/users/coordi", params);
